// Articles du blog. Une seule source pour l'affichage, le sommaire, le sitemap
// et le balisage Article. Chaque article vise une requête de longue traîne.
//
// Règles de conformité (courrier ANAH) reprises ici :
// - 22 000 € est un plafond de TRAVAUX, jamais un montant d'aide ;
// - l'aide maximale est de 15 400 € (70 %) ou 11 000 € (50 %) ;
// - aucun partenariat France Rénov' n'est revendiqué.

export const articles = [
  {
    slug: "comment-obtenir-maprimeadapt",
    titre: "Comment obtenir MaPrimeAdapt' : les étapes concrètes",
    description:
      "De la vérification de votre éligibilité au versement de l'aide : le déroulé réel d'un dossier MaPrimeAdapt', avec les délais et les pièges à éviter.",
    date: "2026-08-05",
    lecture: "6 min",
    resume:
      "Beaucoup de dossiers échouent pour une raison simple : les travaux ont commencé trop tôt. Voici l'ordre dans lequel les choses doivent se passer.",
    sections: [
      {
        titre: "1. Vérifier que vous entrez dans les critères",
        paragraphes: [
          "Trois portes d'entrée existent. Vous avez 70 ans ou plus : aucune justification de perte d'autonomie n'est demandée. Vous avez entre 60 et 69 ans : il faut un justificatif de GIR 1 à 6. Vous êtes en situation de handicap : un taux d'incapacité d'au moins 50 %, l'AAH ou la PCH ouvrent le droit, sans condition d'âge.",
          "S'y ajoute une condition de ressources : votre foyer doit relever de la catégorie « modeste » ou « très modeste » de l'ANAH. Les plafonds dépendent du nombre de personnes au foyer et sont plus élevés en Île-de-France. Enfin, le logement doit être votre résidence principale.",
        ],
      },
      {
        titre: "2. Faire appel à un AMO — c'est obligatoire",
        paragraphes: [
          "Vous ne pouvez pas déposer seul un dossier MaPrimeAdapt'. L'accompagnement par un assistant à maîtrise d'ouvrage est une condition d'obtention de l'aide. C'est lui qui organise la visite d'évaluation, monte le dossier, le dépose et suit le chantier.",
          "Bonne nouvelle : son coût est pris en charge par l'ANAH, à hauteur de 600 € dans le cas général et de 800 € pour les personnes de plus de 80 ans ou ayant subi une chute récente. Vous avancez la somme, elle vous est remboursée avec les aides travaux.",
        ],
      },
      {
        titre: "3. La visite d'évaluation à domicile",
        paragraphes: [
          "Un professionnel se déplace chez vous et observe les gestes du quotidien : entrer dans la douche, monter l'escalier, atteindre les rangements, franchir le seuil d'entrée. Son rapport liste les adaptations justifiées et sert de fondement au dossier.",
          "C'est une étape à ne pas négliger : c'est elle qui relie les travaux demandés à un besoin réel, ce que l'ANAH vérifie. Un ergothérapeute peut intervenir en complément quand la situation le justifie.",
        ],
      },
      {
        titre: "4. Les devis, puis le dépôt du dossier",
        paragraphes: [
          "Vous restez libre de choisir vos artisans. Les devis doivent correspondre aux préconisations du diagnostic et respecter le formalisme attendu par l'ANAH. Le dossier complet est ensuite déposé, puis instruit.",
          "Comptez environ un mois pour la constitution et deux à trois mois d'instruction. Attention : depuis le 17 août 2026, le dépôt se fait depuis un compte personnel unique sur france-renov.gouv.fr, sécurisé par FranceConnect+.",
        ],
      },
      {
        titre: "5. L'erreur qui coûte le plus cher",
        paragraphes: [
          "Ne laissez aucun artisan démarrer avant la notification d'accord de l'ANAH. Des travaux commencés trop tôt ne sont pas finançables, même si le dossier aurait été accepté sur le fond. C'est la principale cause de refus, et elle est irrattrapable.",
          "Une avance sur l'aide peut par ailleurs être demandée selon votre situation, ce qui évite d'avoir à débourser la totalité du chantier avant remboursement.",
        ],
      },
      {
        titre: "6. Réception des travaux et versement",
        paragraphes: [
          "Une fois le chantier terminé, la conformité est vérifiée et les factures transmises. Le versement intervient ensuite, généralement dans les semaines qui suivent. Sur l'ensemble du parcours, comptez trois à six mois entre le premier contact et la fin des travaux.",
        ],
      },
    ],
  },

  {
    slug: "amo-obligatoire-maprimeadapt",
    titre: "L'AMO est-il obligatoire pour MaPrimeAdapt' ? Et combien coûte-t-il ?",
    description:
      "Oui, l'accompagnement AMO conditionne l'obtention de MaPrimeAdapt'. Ce qu'il recouvre, qui le paie, et pourquoi ce n'est pas une commission.",
    date: "2026-08-05",
    lecture: "5 min",
    resume:
      "C'est la question qui revient le plus souvent, souvent avec une inquiétude sur le coût. La réponse tient en deux points : oui c'est obligatoire, et non, cela ne vous coûte rien au final.",
    sections: [
      {
        titre: "Ce que veut dire « AMO »",
        paragraphes: [
          "AMO signifie assistant à maîtrise d'ouvrage. C'est l'opérateur qui prend en charge la partie administrative et technique de votre projet : il représente vos intérêts face à l'ANAH et face aux entreprises, du premier rendez-vous jusqu'au versement de l'aide.",
          "Le recours à un AMO n'est pas une option commerciale : c'est une condition posée par le dispositif. Un dossier MaPrimeAdapt' déposé sans accompagnement n'aboutit pas.",
        ],
      },
      {
        titre: "Ce qu'il fait concrètement",
        paragraphes: [
          "Il vérifie votre éligibilité et votre catégorie de ressources, organise la visite d'évaluation à domicile, traduit les préconisations en travaux chiffrables, contrôle la conformité des devis, constitue et dépose le dossier, suit l'instruction, puis vérifie la bonne exécution des travaux et déclenche la demande de paiement.",
          "Il recherche aussi les aides mobilisables en plus de MaPrimeAdapt' : caisses de retraite, département, commune, PCH. C'est souvent là que se joue la différence sur le reste à charge.",
        ],
      },
      {
        titre: "Qui paie, et combien",
        paragraphes: [
          "La prestation est prise en charge par l'ANAH : 600 € dans le cas général, 800 € pour les personnes de plus de 80 ans ou ayant subi une chute récente. Vous avancez cette somme, puis elle vous est remboursée en même temps que les aides travaux.",
          "Un point de vigilance : cette rémunération est la seule que perçoit un AMO sérieux. Aucune commission ne doit être prélevée sur les devis des artisans. Si on vous propose un « accompagnement gratuit » financé par une marge sur les travaux, demandez le détail.",
        ],
      },
      {
        titre: "Peut-on choisir son AMO ?",
        paragraphes: [
          "Oui, vous choisissez librement votre opérateur, et vous pouvez en changer. Vérifiez qu'il est bien habilité et qu'il intervient réellement dans votre département : la couverture géographique varie beaucoup d'un opérateur à l'autre.",
        ],
      },
    ],
  },

  {
    slug: "douche-senior-normes-et-aides",
    titre: "Remplacer sa baignoire par une douche sénior : normes, prix et aides",
    description:
      "Ce qu'il faut prévoir pour une douche de plain-pied sécurisée, ce que cela coûte réellement et ce que MaPrimeAdapt' prend en charge.",
    date: "2026-08-05",
    lecture: "6 min",
    resume:
      "La salle de bain est le premier poste de travaux demandé, et le premier lieu de chute du domicile. Voici ce qui compte vraiment dans une douche adaptée.",
    sections: [
      {
        titre: "Pourquoi la salle de bain d'abord",
        paragraphes: [
          "Enjamber une baignoire devient un geste risqué bien avant que l'on s'en inquiète. Une douche de plain-pied supprime ce franchissement, et c'est l'aménagement dont le bénéfice est le plus immédiat sur la sécurité comme sur l'autonomie.",
        ],
      },
      {
        titre: "Ce qu'une douche adaptée doit comporter",
        paragraphes: [
          "L'accès de plain-pied, sans ressaut, est le point central : un receveur extra-plat ou un receveur à carreler permet d'y parvenir. Le sol doit être antidérapant, avec un revêtement dont l'adhérence reste correcte une fois mouillé.",
          "Il faut ensuite des barres d'appui posées dans l'axe des appuis réels — pas décoratives, fixées dans le support porteur — un siège de douche escamotable ou fixe, une robinetterie thermostatique pour éviter les brûlures, et un espace de manœuvre suffisant si un déambulateur ou un fauteuil doit entrer.",
        ],
      },
      {
        titre: "Combien ça coûte",
        paragraphes: [
          "Pour un remplacement complet baignoire vers douche sécurisée, avec reprise de l'étanchéité, du sol et de la robinetterie, l'ordre de grandeur se situe entre 5 000 et 10 000 € selon la configuration de la pièce et les finitions.",
          "Sur un devis de 8 400 € et un taux de 70 %, MaPrimeAdapt' apporte 5 880 €, soit un reste à charge de 2 520 € avant les autres aides. À 50 %, l'aide s'élève à 4 200 €.",
        ],
      },
      {
        titre: "Ce que finance MaPrimeAdapt'",
        paragraphes: [
          "L'aide couvre 70 % du montant des travaux pour les ménages aux ressources très modestes et 50 % pour les ménages modestes, dans la limite de 22 000 € HT de travaux retenus — soit une aide maximale de 15 400 €.",
          "Le lien avec la perte d'autonomie doit être établi par la visite d'évaluation. Une rénovation esthétique de salle de bain sans dimension d'adaptation ne relève pas du dispositif.",
        ],
      },
      {
        titre: "L'ordre à respecter",
        paragraphes: [
          "Faites établir le diagnostic, puis les devis, puis déposez le dossier, et attendez l'accord avant de commencer. Un chantier lancé avant la notification n'est pas finançable.",
        ],
      },
    ],
  },

  {
    slug: "maprimeadapt-2026-ce-qui-change",
    titre: "MaPrimeAdapt' au 17 août 2026 : ce qui change vraiment",
    description:
      "MaPrimeRénov', Mon Projet Anah et France Rénov' fusionnent dans un compte unique. Ce que cela change pour votre dossier, et ce que cela ne change pas.",
    date: "2026-08-05",
    lecture: "4 min",
    resume:
      "La réforme touche la plateforme, pas les droits. Mais elle impose une fenêtre de fermeture qu'il vaut mieux anticiper.",
    sections: [
      {
        titre: "Un compte personnel unique",
        paragraphes: [
          "Depuis le 17 août 2026, MaPrimeRénov', Mon Projet Anah et France Rénov' sont regroupés dans un espace personnel unique hébergé sur france-renov.gouv.fr. L'accès est sécurisé par FranceConnect+, un niveau d'authentification plus élevé que FranceConnect classique.",
          "Concrètement, un même compte donne désormais accès à l'ensemble des aides de l'ANAH, qu'il s'agisse de rénovation énergétique ou d'adaptation du logement.",
        ],
      },
      {
        titre: "La fenêtre de fermeture du 3 au 17 août",
        paragraphes: [
          "Les trois plateformes ont été fermées du 3 au 17 août 2026 pour la migration. Pendant cette période, aucun compte ne pouvait être créé et aucun dossier déposé.",
          "C'est le point pratique à retenir : si votre projet était en cours à ce moment-là, le travail préparatoire — visite d'évaluation, devis, pièces justificatives — pouvait se poursuivre normalement, seul le dépôt était suspendu.",
        ],
      },
      {
        titre: "Ce qui ne change pas",
        paragraphes: [
          "Ni les montants d'aide, ni les plafonds de ressources, ni les critères d'éligibilité ne sont modifiés par cette migration. Les taux restent de 70 % pour les ménages très modestes et 50 % pour les ménages modestes, sur des travaux plafonnés à 22 000 € HT.",
          "L'accompagnement par un AMO reste obligatoire, et sa prise en charge par l'ANAH est maintenue.",
        ],
      },
      {
        titre: "Si vous aviez déjà un compte Mon Projet Anah",
        paragraphes: [
          "Les dossiers existants ont été repris dans le nouvel espace. Si vous ne retrouvez pas le vôtre, l'identification via FranceConnect+ est la première chose à vérifier : c'est elle qui rattache votre dossier à votre identité.",
        ],
      },
    ],
  },

  {
    slug: "reste-a-charge-adaptation-logement",
    titre: "Reste à charge : ce que vous payez vraiment après les aides",
    description:
      "Trois projets d'adaptation chiffrés du devis au reste à charge, et les leviers qui font réellement baisser la facture.",
    date: "2026-08-05",
    lecture: "5 min",
    resume:
      "Le taux de 70 % ne dit pas tout. Ce qui compte, c'est ce qu'il reste à sortir de sa poche une fois toutes les aides mobilisées.",
    sections: [
      {
        titre: "Comment se calcule l'aide",
        paragraphes: [
          "MaPrimeAdapt' s'applique au montant des travaux retenus, dans la limite de 22 000 € HT. Le taux dépend de votre catégorie de ressources : 70 % pour les ménages très modestes, 50 % pour les ménages modestes. L'aide ne peut donc pas dépasser 15 400 €.",
          "Ce plafond s'apprécie sur cinq ans et par logement : mieux vaut traiter l'ensemble des besoins en une fois plutôt que de fractionner sans raison.",
        ],
      },
      {
        titre: "Trois exemples chiffrés",
        paragraphes: [
          "Douche sécurisée à 8 400 € : à 70 %, l'aide est de 5 880 € et le reste à charge de 2 520 €. À 50 %, l'aide tombe à 4 200 € et le reste à charge monte à 4 200 €.",
          "Monte-escalier droit à 6 200 € : à 50 %, l'aide est de 3 100 €, soit autant de reste à charge. À 70 %, le reste à charge descend à 1 860 €.",
          "Adaptation complète — douche, WC surélevé, barres d'appui, éclairage, seuils — à 18 000 € : à 70 %, l'aide atteint 12 600 € et le reste à charge 5 400 €.",
        ],
      },
      {
        titre: "Les leviers qui font vraiment baisser la facture",
        paragraphes: [
          "Le premier est le cumul. Les caisses de retraite interviennent souvent sur ce type de travaux, tout comme certains départements et communes d'Île-de-France. La PCH peut compléter pour les personnes en situation de handicap, et l'APA finance des aménagements pour les personnes en perte d'autonomie.",
          "Le second est la TVA : les travaux d'accessibilité relèvent d'un taux réduit, ce qui pèse directement sur le devis. Vérifiez que votre artisan l'a bien appliqué.",
          "Le troisième est la qualité du chiffrage. Un devis mal découpé peut faire sortir du périmètre finançable des postes qui y avaient leur place.",
        ],
      },
      {
        titre: "Et l'accompagnement dans tout ça",
        paragraphes: [
          "Il n'entre pas dans votre reste à charge : les 600 € ou 800 € d'AMO sont pris en charge par l'ANAH et vous sont remboursés.",
        ],
      },
    ],
  },

  {
    slug: "cumul-aides-maprimeadapt",
    titre: "Cumuler MaPrimeAdapt' avec les autres aides : le mode d'emploi",
    description:
      "Caisses de retraite, PCH, APA, aides départementales et communales : lesquelles se cumulent avec MaPrimeAdapt' et dans quel ordre les demander.",
    date: "2026-08-05",
    lecture: "5 min",
    resume:
      "MaPrimeAdapt' est rarement la seule aide mobilisable. C'est l'empilement qui rend un projet réellement finançable.",
    sections: [
      {
        titre: "Les caisses de retraite",
        paragraphes: [
          "La CARSAT, la MSA et les caisses complémentaires financent des travaux d'adaptation pour leurs assurés, sous conditions de ressources et selon un barème propre à chaque caisse. C'est souvent le complément le plus significatif après MaPrimeAdapt'.",
          "Le dossier est distinct et se demande auprès de la caisse. Il vaut mieux le lancer en parallèle du dossier ANAH, les délais d'instruction se recouvrant.",
        ],
      },
      {
        titre: "La PCH et l'APA",
        paragraphes: [
          "La prestation de compensation du handicap est attribuée par la MDPH au titre de la compensation, avec une logique différente de celle de l'ANAH. Elle peut financer des aménagements du logement et se combine avec MaPrimeAdapt'.",
          "L'allocation personnalisée d'autonomie, versée par le département, comporte également un volet aménagement pour les personnes en perte d'autonomie. Les deux dispositifs ne s'adressent pas au même public : on ne cumule pas PCH et APA entre elles.",
        ],
      },
      {
        titre: "Les collectivités d'Île-de-France",
        paragraphes: [
          "Région, départements et communes disposent de dispositifs propres, parfois généreux, souvent méconnus, et dont les critères changent régulièrement. Leur montant varie fortement d'une commune à l'autre : c'est un travail de recherche au cas par cas, à faire au moment du montage du dossier.",
        ],
      },
      {
        titre: "Dans quel ordre s'y prendre",
        paragraphes: [
          "Commencez par MaPrimeAdapt' : c'est l'aide principale, et son instruction conditionne le calendrier. Déposez les demandes complémentaires en parallèle, en veillant à ce que les devis soient identiques d'un dossier à l'autre.",
          "Un point de vigilance : le cumul ne peut pas dépasser le montant des travaux. Les aides se complètent, elles ne se superposent pas au-delà de la dépense réelle.",
        ],
      },
      {
        titre: "Peut-on arriver à zéro reste à charge ?",
        paragraphes: [
          "Cela se voit sur des projets modestes portés par un ménage très modeste, avec une caisse de retraite et une commune qui interviennent. Mais ce n'est pas la règle, et se le faire promettre à l'avance, sans étude de votre situation, doit vous alerter.",
        ],
      },
    ],
  },

  {
    slug: "travaux-accessibilite-copropriete",
    titre: "Travaux d'accessibilité en copropriété : ce que vous pouvez imposer",
    description:
      "Monte-escalier, rampe, élargissement : l'article 25-2 de la loi de 1965 empêche l'assemblée générale de refuser sans motif vos travaux d'accessibilité.",
    date: "2026-08-06",
    lecture: "7 min",
    resume:
      "La plupart des copropriétaires croient devoir obtenir un vote favorable de l'assemblée générale. C'est l'inverse : la loi prévoit que l'assemblée doit motiver son opposition, faute de quoi les travaux peuvent être réalisés.",
    sections: [
      {
        titre: "Le malentendu de départ",
        paragraphes: [
          "« Il faut que je fasse voter ça en AG, autant dire que c'est mort. » C'est la phrase que nous entendons le plus souvent dès qu'un projet touche à l'escalier commun, au hall ou à la marche du perron. Elle repose sur une idée fausse : que tous les travaux affectant les parties communes exigent une autorisation votée à la majorité.",
          "Depuis l'article 25-2 de la loi du 10 juillet 1965, ce n'est plus le cas pour les travaux d'accessibilité aux personnes handicapées ou à mobilité réduite réalisés aux frais du copropriétaire. Le mécanisme est inversé : ce n'est pas à vous d'obtenir un accord, c'est à l'assemblée de motiver un refus.",
        ],
      },
      {
        titre: "La procédure exacte",
        paragraphes: [
          "Vous notifiez au syndic une demande d'inscription à l'ordre du jour de la prochaine assemblée générale. Attention au vocabulaire : il s'agit d'une inscription pour information, pas d'une résolution soumise au vote.",
          "Cette notification doit être accompagnée d'un descriptif détaillé des travaux envisagés. La jurisprudence est exigeante sur ce point : nature, emplacement, durée et conditions d'exécution des travaux, mais aussi les éléments essentiels de l'équipement — marque, modèle, notice, garanties, documents d'utilisation et d'entretien. Un descriptif vague est le meilleur moyen de fournir un motif d'opposition.",
        ],
      },
      {
        titre: "Ce que l'assemblée peut encore refuser",
        paragraphes: [
          "L'assemblée générale peut s'opposer aux travaux, mais uniquement par une décision motivée, et sur des fondements limitativement énumérés : l'atteinte à la structure de l'immeuble ou à ses éléments d'équipement essentiels, ou la non-conformité des travaux à la destination de l'immeuble.",
          "Autrement dit : « ça va faire baisser la valeur de l'immeuble », « ce n'est pas esthétique » ou « personne d'autre n'en a besoin » ne sont pas des motifs recevables. En revanche, un rail fixé sur un escalier classé ou un dispositif qui réduirait la largeur de passage sous le minimum réglementaire pour l'évacuation incendie relève bien des motifs prévus.",
        ],
      },
      {
        titre: "Le calendrier réel",
        paragraphes: [
          "En l'absence d'opposition motivée, vous pouvez faire réaliser les travaux conformément au descriptif transmis, après l'expiration du délai de contestation des décisions d'assemblée générale, qui est de deux mois.",
          "Concrètement, le facteur limitant n'est pas le droit mais la date de l'assemblée : elle se tient une fois par an. Si votre AG a lieu en mai et que le besoin apparaît en juin, l'attente est longue. C'est la raison pour laquelle nous conseillons de notifier le syndic dès que le projet se dessine, avant même d'avoir arrêté tous les devis — quitte à préciser ensuite.",
        ],
      },
      {
        titre: "À qui appartiennent les travaux ensuite",
        paragraphes: [
          "C'est le point que les copropriétaires découvrent souvent après coup : les travaux réalisés ne constituent pas une propriété privative. Tout élément incorporé aux parties communes est présumé commun, et son entretien sera, le cas échéant, réparti entre les copropriétaires selon le règlement de copropriété.",
          "Cela ne change rien à votre droit de faire les travaux, ni au fait que vous en supportez le coût initial. Mais c'est un argument à connaître, parce qu'il désamorce souvent l'objection principale en assemblée : l'équipement bénéficie à l'immeuble, pas à un seul appartement.",
        ],
      },
      {
        titre: "Et pour l'intérieur du logement",
        paragraphes: [
          "Tout ce qui reste dans vos parties privatives — remplacer la baignoire par une douche de plain-pied, poser des barres d'appui, rehausser les WC, élargir une porte intérieure, motoriser les volets — ne demande aucune formalité vis-à-vis de la copropriété.",
          "Deux réserves tout de même. Toucher à une canalisation d'évacuation qui traverse plusieurs logements, ou modifier un mur porteur, sort du champ privatif. Et la modification de l'aspect extérieur, y compris de vos propres fenêtres, reste soumise aux règles habituelles.",
        ],
      },
      {
        titre: "Ce que nous faisons sur ce volet",
        paragraphes: [
          "Le montage du dossier MaPrimeAdapt' et la démarche en copropriété avancent en parallèle. Nous préparons le descriptif détaillé à notifier au syndic, avec les pièces techniques de l'équipement retenu, et nous calons le calendrier des travaux sur la date de l'assemblée générale pour éviter que le dossier ANAH n'expire en attendant.",
        ],
      },
    ],
  },

  {
    slug: "gir-evaluation-autonomie",
    titre: "GIR 1 à 6 : comment votre autonomie est évaluée, et pourquoi ça compte",
    description:
      "Entre 60 et 69 ans, MaPrimeAdapt' exige un GIR. Ce qu'est la grille AGGIR, qui l'évalue, et pourquoi un GIR élevé n'est pas un mauvais résultat.",
    date: "2026-08-06",
    lecture: "6 min",
    resume:
      "Beaucoup de personnes renoncent en croyant qu'il faut être « assez dépendant » pour avoir droit à MaPrimeAdapt'. C'est l'inverse de l'esprit du dispositif, qui est préventif.",
    sections: [
      {
        titre: "Quand le GIR est demandé, et quand il ne l'est pas",
        paragraphes: [
          "Trois portes d'entrée existent pour MaPrimeAdapt', et une seule passe par le GIR. À partir de 70 ans, aucune évaluation n'est nécessaire : l'âge suffit, sous réserve des conditions de ressources. En situation de handicap, un taux d'incapacité d'au moins 50 % ou le bénéfice de la PCH ouvrent le droit, sans condition d'âge.",
          "C'est uniquement entre 60 et 69 ans qu'un GIR compris entre 1 et 6 doit être justifié. Et c'est là que la confusion commence.",
        ],
      },
      {
        titre: "GIR 1 à 6 : cela couvre tout le monde",
        paragraphes: [
          "La grille AGGIR classe les personnes en six groupes iso-ressources, du plus dépendant au plus autonome. Le GIR 1 correspond aux personnes confinées au lit ou au fauteuil dont les fonctions mentales sont gravement altérées. À l'autre extrémité, le GIR 6 désigne les personnes autonomes pour tous les actes essentiels de la vie courante.",
          "Autrement dit, exiger un « GIR 1 à 6 » revient à demander une évaluation, pas un niveau de dépendance. Une personne parfaitement autonome est en GIR 6, et le GIR 6 est éligible. C'est le point que nous devons expliquer presque à chaque appel : on nous dit « ma mère va très bien, elle ne rentrera jamais dans les cases », alors qu'elle y est déjà.",
        ],
      },
      {
        titre: "Ce que regarde concrètement la grille",
        paragraphes: [
          "L'évaluation porte sur des activités observables, pas sur des diagnostics médicaux. Dix variables dites discriminantes sont notées : cohérence, orientation, toilette, habillage, alimentation, élimination, transferts, déplacements à l'intérieur, déplacements à l'extérieur, communication à distance.",
          "Chacune est cotée selon que l'activité est faite seul, spontanément, totalement et habituellement — ou non. Ce sont ces quatre adverbes qui font la différence : quelqu'un qui se lave seul mais met quarante minutes et évite la baignoire ne coche pas « habituellement » et « totalement » de la même façon que six mois plus tôt.",
        ],
      },
      {
        titre: "Qui réalise l'évaluation",
        paragraphes: [
          "Si vous percevez déjà l'APA, votre GIR est connu : il figure sur la notification du conseil départemental, et ce document suffit. L'APA n'étant ouverte qu'aux GIR 1 à 4, cette voie ne concerne qu'une partie des demandeurs.",
          "Sinon, l'évaluation est réalisée dans le cadre de l'accompagnement, par un professionnel formé à la grille. Elle se fait à domicile, en même temps que la visite d'évaluation du logement, ce qui évite un déplacement supplémentaire. Un médecin traitant peut également établir le classement.",
        ],
      },
      {
        titre: "Pourquoi l'évaluation à domicile change le dossier",
        paragraphes: [
          "Un point pratique qui a des conséquences réelles : la grille se remplit beaucoup mieux chez vous qu'en consultation. Une salle de bain se juge en regardant quelqu'un s'approcher de la baignoire, pas en le lui demandant.",
          "C'est aussi ce qui relie l'évaluation aux travaux demandés. L'ANAH vérifie que les adaptations financées répondent à un besoin identifié. Un dossier où le GIR est établi à domicile, dans la continuité du diagnostic du logement, est nettement plus solide qu'un dossier où les deux documents ont été produits séparément.",
        ],
      },
      {
        titre: "Le GIR ne détermine pas le montant de l'aide",
        paragraphes: [
          "Dernière confusion fréquente : le GIR conditionne l'éligibilité entre 60 et 69 ans, mais il n'entre pas dans le calcul du montant. Ce sont vos ressources qui fixent le taux — 70 % pour les ménages très modestes, 50 % pour les ménages modestes — dans la limite d'un plafond de travaux de 22 000 € HT.",
          "Un GIR 6 et un GIR 3 aux mêmes revenus perçoivent donc la même aide sur le même projet. Ce qui varie, ce sont les travaux justifiés par la situation, pas le pourcentage.",
        ],
      },
    ],
  },

  {
    slug: "refus-maprimeadapt-motifs-recours",
    titre: "MaPrimeAdapt' refusée : les motifs réels et ce qu'on peut encore faire",
    description:
      "Travaux commencés trop tôt, ressources au-dessus du plafond, devis non conformes : les causes de refus les plus fréquentes, et lesquelles se rattrapent.",
    date: "2026-08-06",
    lecture: "6 min",
    resume:
      "Certains refus sont définitifs, d'autres sont de simples problèmes de dossier. Savoir dans quelle catégorie on se trouve évite de perdre des mois — ou d'abandonner à tort.",
    sections: [
      {
        titre: "1. Les travaux ont commencé avant l'accord",
        paragraphes: [
          "C'est le motif le plus fréquent et le seul qui soit vraiment irrattrapable. Aucun travail ne doit démarrer avant la notification d'accord de l'ANAH. Un acompte versé, un artisan qui a livré le matériel, une première journée de chantier : cela suffit à faire tomber le dossier, même s'il aurait été accepté sur le fond.",
          "Il n'existe pas de dérogation pour urgence, et le fait d'ignorer la règle n'est pas un moyen de défense. La seule prévention est de le savoir avant, et de résister à la pression commerciale d'un installateur qui propose de commencer tout de suite.",
        ],
      },
      {
        titre: "2. Les ressources dépassent les plafonds",
        paragraphes: [
          "Refus de principe, mais il vaut la peine de vérifier deux choses avant d'abandonner. D'abord, le revenu retenu est le revenu fiscal de référence de l'année N-1 : un départ à la retraite intervenu depuis fait souvent basculer un foyer d'une catégorie à l'autre, et une demande déposée l'année suivante peut passer.",
          "Ensuite, le nombre d'occupants du logement doit être exact — c'est l'effectif réel qui compte, pas la composition du foyer fiscal. Une erreur d'une personne déplace le plafond de plusieurs milliers d'euros.",
          "Si vous restez au-dessus, d'autres dispositifs prennent le relais : caisse de retraite, volet aides techniques de l'APA, PCH pour les personnes en situation de handicap, et les aides locales du département ou de la commune.",
        ],
      },
      {
        titre: "3. Les travaux ne sont pas jugés justifiés",
        paragraphes: [
          "L'ANAH finance des adaptations liées à la perte d'autonomie, pas une rénovation. Un dossier qui inclut le carrelage de toute la maison au motif qu'on refait la salle de bain sera au mieux réduit, au pire refusé.",
          "Ce motif se corrige. Il traduit presque toujours un défaut de lien entre le diagnostic et les devis : les travaux demandés ne découlent pas visiblement des difficultés constatées. Reprendre le dossier en resserrant le périmètre sur ce qui est réellement justifié permet en général de le représenter.",
        ],
      },
      {
        titre: "4. Les devis ne sont pas conformes",
        paragraphes: [
          "Devis non détaillés, postes forfaitaires impossibles à rattacher aux préconisations, mentions obligatoires manquantes, matériel non identifié : ce sont des motifs de rejet purement formels, et ils sont fréquents chez les artisans qui n'ont pas l'habitude des dossiers ANAH.",
          "C'est le type de refus le plus facile à corriger, et aussi celui qui coûte le plus de temps quand il arrive après trois mois d'instruction. Faire vérifier les devis avant dépôt est précisément l'une des raisons d'être de l'accompagnement.",
        ],
      },
      {
        titre: "5. Le dossier est incomplet",
        paragraphes: [
          "Avis d'imposition manquant, justificatif de propriété absent, GIR non produit pour un demandeur de 60 à 69 ans. Ce n'est pas un refus au sens strict mais une demande de pièces, et le dossier reste ouvert. Le risque est ailleurs : l'instruction est suspendue pendant ce temps, et le calendrier des devis, souvent valables trois mois, s'en trouve décalé.",
        ],
      },
      {
        titre: "Comment contester",
        paragraphes: [
          "Un refus se conteste d'abord par un recours gracieux auprès de la délégation locale de l'ANAH qui a instruit le dossier, dans un délai de deux mois à compter de la notification. Le courrier doit répondre point par point au motif invoqué et joindre les pièces qui manquaient ou les devis rectifiés.",
          "En pratique, quand le motif est formel — devis, périmètre des travaux, pièces —, reprendre le dossier proprement est plus efficace et plus rapide qu'un contentieux. Quand le motif est de fond — ressources, travaux déjà engagés —, le recours n'a pratiquement aucune chance d'aboutir, et l'énergie est mieux employée à chercher les dispositifs alternatifs.",
        ],
      },
    ],
  },
];

export const trouverArticle = (slug) => articles.find((a) => a.slug === slug);
